import api from "api/api";

export const getMyNotificationsQuery = async ({
  lang,
  archived,
  page,
  limit,
  read,
}) =>
  await api.get(
    `/alerts/notifications?lang=${lang || "Fr"}${
      archived ? `&archived=${archived}` : ``
    }&page=${page || 1}${limit ? `&limit=${limit}` : ``}${
      read ? `&read=${read}` : ``
    }`
  );

export const updateNotificationsQuery = async ({ data }) =>
  await api.put(`/alerts/notifications`, data);

export const deleteNotificationsQuery = async ({ data }) =>
  await api.delete(`/alerts/notifications`, data);
